/* eslint-disable no-unused-vars */
import { MobileSideNavLinks } from "../SideNav/MobileSideNavConfig";
import { clearQueryStrings } from "../../hooks/queryString";
import { HeaderLinks } from "./HeaderConfig";
import { Collapse, Drawer, IconButton, List, ListItem, ListItemText, ListItemSecondaryAction, Tabs, Tab, makeStyles } from "@material-ui/core";
import HamburgerIcon from "@material-ui/icons/Menu";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import OpenIcon from "@material-ui/icons/OpenInNew";
import React, { useContext, useState } from "react";
import MobileAppSearch from "./AppSearch/MobileAppSearch";
import GeoSelector from "../GeoSelector/GeoSelector";

import "./MobileHeader.scss";
import { GeoContext } from "../../context/GeoContext";
import XIcon from "calcite-ui-icons-react/XIcon";

export function MobileHeader(props) {
    const { setAppDrawerDir, setDrawerHalfOpen, app, setApp } = props;

    // this hamburger is expexting a pretty specific format to the links, it will fail if the link structure ever changes
    const linksWOchildren = HeaderLinks.filter((h) => !h.children || !h.children.length);
    const linkWchildren = HeaderLinks.find((h) => h.children && h.children.length);

    const [tab, setTab] = useState(0);
    const [subOpen, setSubOpen] = useState(false);

    const [open, setOpen] = useState(false);
    const { setSelectedGeometry } = useContext(GeoContext);

    /**
    * Simple handler for when the user selects a new geometry. Update in state
    */
    const handleGeometryChange = (geometry) => {
        setSelectedGeometry(geometry);
        setDrawerHalfOpen(false);
        setAppDrawerDir(false);
        props.setBasemapOpen(false);
    };

    /**
    * Simple handler for when the user toggle the geo scaler. Update in state
    */
    // const onGeoScaleToggle = () => {
    //     setIsGeoScaled(!isGeoScaled);
    // };

    const menuClick = (e) => {
        e.stopPropagation();
        setOpen(!open);
    }

    const handleNavClick = (newApp) => {
        if (app !== newApp) {
            clearQueryStrings();
            setApp(newApp);
        }
        closeMenu();
        props.setBasemapOpen(false);
        setAppDrawerDir(false);
        setDrawerHalfOpen(true);
    };

    const subMenuClick = (e) => {
        e.stopPropagation(); //else it will close the popover
        setSubOpen(!subOpen);
    };

    const linkClicked = (e, url) => {
        e.stopPropagation(); //else it will close the popover
        window.open(url);
    };

    const closeMenu = () => {
        setOpen(false);
        setSubOpen(false);
    };

    const changeTab = (e, index) => {
        e.stopPropagation();
        setTab(index);
    }

    const useStyles = makeStyles({
        link: {
            fontFamily: 'Lato',
            color: '#031D44',
            '&.active': {
                fontWeight: 'bold',
            }
        },
        tab: {
            fontFamily: 'Lato',
            color: '#031D44',
            textTransform: 'uppercase',
            fontWeight: '700',
            letterSpacing: '0.8px',
        },
    });

    const classes = useStyles();

    return (
        <>
            <div className="appHeader">
                <div className="navMenu">
                    <IconButton aria-describedby={"hamburger"}
                        className="hamburger"
                        onClick={menuClick}
                        color="primary" 
                        ria-label="open menu"
                        component="span"
                        style={{ borderRadius: '0' }}>
                        <HamburgerIcon />
                    </IconButton>
                </div>
                <div className="titleArea">
                    <h1 className="appTitle">
                        OECS
                    </h1>
                </div>
                {app !== "intro" && (
                <div className="geoSelect">
                    <GeoSelector handleOnChange={handleGeometryChange} setBasemapOpen={props.setBasemapOpen} />
                </div>
                )}
                <div className="searchArea">
                    <MobileAppSearch 
                        setBasemapOpen={props.setBasemapOpen}
                        setAppDrawerDir={props.setAppDrawerDir}
                        setDrawerHalfOpen={props.setDrawerHalfOpen}
                        setViewLegendOpen={props.setViewLegendOpen}
                    />
                </div>
                </div>
            <Drawer
                anchor="left"
                open={open}
                onClose={closeMenu}
                className="hamDrawer"
            >
                <div className="drawerHeader">
                    <Tabs 
                        variant="fullWidth"
                        value={tab}
                        onChange={changeTab}
                        TabIndicatorProps={{ style: {backgroundColor: '#035bd8'}}}
                    >
                        <Tab disableRipple className={classes.tab} value={0} label="Apps" />
                        <Tab disableRipple className={classes.tab} value={1} label="Links" />
                    </Tabs>
                    <IconButton
                        onClick={closeMenu}
                        type="button"
                        style={{
                            color: '#031D44',
                        }}
                        aria-label="close menu" component="span">
                        <XIcon />
                    </IconButton>
                </div>

                {tab === 0 &&
                    (<List className="appLinks">
                        {MobileSideNavLinks.map((app) => (
                            <ListItem
                                button
                                key={app.url}
                                onClick={() => handleNavClick(app.url)}
                                className={`${classes.link} ${props.app === app.url ? 'active' : ''}`}
                            >
                                {app.title}
                            </ListItem>
                        ))}
                    </List>)}
                {tab === 1 &&
                    <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        className="navList"
                    >
                        {linksWOchildren.map((lnk) => (
                            <ListItem
                                button
                                key={lnk.label}
                                className="linkItem"
                                onClick={(e) => linkClicked(e, lnk.url)}
                            >
                                <ListItemText primary={lnk.label} />
                                <ListItemSecondaryAction>
                                    <OpenIcon />
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}

                        {linkWchildren && (
                            <ListItem button onClick={subMenuClick}>
                                <ListItemText primary={linkWchildren.label} />
                                {subOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                        )}
                        {linkWchildren && (
                            <Collapse in={subOpen} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {linkWchildren.children.map((child) => (
                                        <ListItem
                                            key={child.label}
                                            button
                                            className="linkItem nested"
                                            onClick={(e) => linkClicked(e, child.url)}
                                        >
                                            <ListItemText primary={child.label} />
                                            <ListItemSecondaryAction>
                                                <OpenIcon />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        )}
                    </List>
                }
            </Drawer>
        </>
    )
}